<template>
  <div class="teams-promo-wrapper">
    <Button
      @click.stop.prevent="open()"
      data-testid="invite-team-members-btn"
      class="!w-full"
      :class="{ 'teams-promo-button-disabled': isAtUserLimit }"
      icon="general.plus"
      type="solid"
      variant="secondary-blue"
      size="medium"
      :submit="true"
    >
      Invite teammates
    </Button>
  </div>
</template>

<script lang="ts" setup>
import { useModal } from '@/storybook/modal/useModal';
import InviteModal from '../InviteModal.vue';
import { Button } from '@/storybook';
import { useUserSeats } from '@/composables/useUserSeats';
import './sidebar.css';

const { open } = useModal(InviteModal);
const { isAtUserLimit } = useUserSeats();
</script>

<style scoped>
.teams-promo-button-disabled {
  @apply opacity-50 cursor-pointer;
}
</style>
